function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "pedigree-7gen-far");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "pedigree-7gen-far",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "han",
  fillOpacity: 0.316462862,
  fill: "#B0E0FF",
  fillRule: "nonzero",
  x: 0,
  y: 35,
  width: 247,
  height: 1590
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 122.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 229.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 50.5,
  y: 429.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 30.5,
  y: 829.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 152.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 324.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 74.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#979797",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 52.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 97.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 274.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 252.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 297.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 174.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 197.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 352.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 374.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 397.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 522.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 629.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 552.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 724.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 474.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 452.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 497.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 674.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 652.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 697.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 574.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 597.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 752.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 774.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 797.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 922.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 1029.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 50.5,
  y: 1229.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 952.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 1124.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 874.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 852.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 897.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1074.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1052.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1097.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 974.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 997.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1152.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1174.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1197.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 1322.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 1429.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1352.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 1524.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1274.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1252.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1297.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1474.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1452.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1497.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1374.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1397.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1552.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1574.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1597.5,
  width: 12,
  height: 12
}), React.createElement("text", {
  id: "headline",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 12,
  fontWeight: 300,
  fill: "#417505"
}, React.createElement("tspan", {
  x: 7,
  y: 17
}, "STAMTAVLE - 8 Generasjoner")), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 72.7,
  y: 132
}, "5")), React.createElement("text", {
  id: "name-0000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 132
})), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 62.7,
  y: 239
}, "4")), React.createElement("text", {
  id: "name-000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 239
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 52.7,
  y: 439
}, "3")), React.createElement("text", {
  id: "name-00",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 67,
  y: 439
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 32.7,
  y: 839
}, "2")), React.createElement("text", {
  id: "name-0",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 47,
  y: 839
})), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 92.7,
  y: 162
}, "7")), React.createElement("text", {
  id: "name-000010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 162
})), React.createElement("text", {
  id: "name-0000100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 152
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 334
}, "5")), React.createElement("text", {
  id: "name-0001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 334
})), React.createElement("line", {
  x1: 65.4027778,
  y1: 130.334483,
  x2: 65.4027778,
  y2: 226.665517,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 129.5,
  x2: 67.5,
  y2: 129.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 236.334483,
  x2: 55.4027778,
  y2: 425.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 235.5,
  x2: 57.5,
  y2: 235.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.4027778,
  y1: 436.334483,
  x2: 35.4027778,
  y2: 822.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.34375,
  y1: 435.5,
  x2: 46.5,
  y2: 435.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 92.7,
  y: 62
}, "7")), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 82.7,
  y: 84
}, "6")), React.createElement("text", {
  id: "name-00000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 84
})), React.createElement("text", {
  id: "name-000000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 62
})), React.createElement("text", {
  id: "name-0000000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 52
})), React.createElement("text", {
  id: "name-0000001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 72
})), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 92.7,
  y: 107
}, "7")), React.createElement("text", {
  id: "name-000001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 107
})), React.createElement("text", {
  id: "name-0000010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 97
})), React.createElement("text", {
  id: "name-0000011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 117
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 80.3344828,
  x2: 75.4027778,
  y2: 119.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 79.5,
  x2: 77.5,
  y2: 79.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 284
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 262
}, "7")), React.createElement("text", {
  id: "name-00010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 284
})), React.createElement("text", {
  id: "name-000100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 262
})), React.createElement("text", {
  id: "name-0001000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 252
})), React.createElement("text", {
  id: "name-0001001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 272
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 307
}, "7")), React.createElement("text", {
  id: "name-000101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 307
})), React.createElement("text", {
  id: "name-0001010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 297
})), React.createElement("text", {
  id: "name-0001011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 317
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 280.334483,
  x2: 75.4027778,
  y2: 319.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 279.5,
  x2: 77.5,
  y2: 279.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 82.7,
  y: 184
}, "6")), React.createElement("text", {
  id: "name-00001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 184
})), React.createElement("text", {
  id: "name-0000101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 172
})), React.createElement("text", {
  id: "far-title-copy-6",
  fill: "#848484",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300
}, React.createElement("tspan", {
  x: 92.7,
  y: 207
}, "7")), React.createElement("text", {
  id: "name-000011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 207
})), React.createElement("text", {
  id: "name-0000110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 197
})), React.createElement("text", {
  id: "name-0000111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 217
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 140.334483,
  x2: 75.4027778,
  y2: 179.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 180.5,
  x2: 77.5,
  y2: 180.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 362
}, "7")), React.createElement("text", {
  id: "name-000110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 362
})), React.createElement("text", {
  id: "name-0001100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 352
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 384
}, "6")), React.createElement("text", {
  id: "name-00011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 384
})), React.createElement("text", {
  id: "name-0001101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 372
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 407
}, "7")), React.createElement("text", {
  id: "name-000111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 407
})), React.createElement("text", {
  id: "name-0001110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 397
})), React.createElement("text", {
  id: "name-0001111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 417
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 340.334483,
  x2: 75.4027778,
  y2: 379.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 380.5,
  x2: 77.5,
  y2: 380.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 245.5,
  x2: 65.4027778,
  y2: 329.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 330.5,
  x2: 67.5,
  y2: 330.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 532
}, "5")), React.createElement("text", {
  id: "name-0010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 532
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 639
}, "4")), React.createElement("text", {
  id: "name-001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 639
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 562
}, "7")), React.createElement("text", {
  id: "name-001010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 562
})), React.createElement("text", {
  id: "name-0010100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 552
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 734
}, "5")), React.createElement("text", {
  id: "name-0011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 734
})), React.createElement("line", {
  x1: 65.34375,
  y1: 529.5,
  x2: 67.5,
  y2: 529.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 484
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 462
}, "7")), React.createElement("text", {
  id: "name-00100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 484
})), React.createElement("text", {
  id: "name-001000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 462
})), React.createElement("text", {
  id: "name-0010000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 452
})), React.createElement("text", {
  id: "name-0010001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 472
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 507
}, "7")), React.createElement("text", {
  id: "name-001001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 507
})), React.createElement("text", {
  id: "name-0010010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 497
})), React.createElement("text", {
  id: "name-0010011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 517
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 480.334483,
  x2: 75.4027778,
  y2: 519.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.5,
  y1: 529.5,
  x2: 65.4027778,
  y2: 625.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 479.5,
  x2: 77.5,
  y2: 479.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 684
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 662
}, "7")), React.createElement("text", {
  id: "name-00110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 684
})), React.createElement("text", {
  id: "name-001100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 662
})), React.createElement("text", {
  id: "name-0011000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 652
})), React.createElement("text", {
  id: "name-0011001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 672
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 707
}, "7")), React.createElement("text", {
  id: "name-001101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 707
})), React.createElement("text", {
  id: "name-0011010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 697
})), React.createElement("text", {
  id: "name-0011011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 717
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 680.334483,
  x2: 75.4027778,
  y2: 719.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 679.5,
  x2: 77.5,
  y2: 679.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 584
}, "6")), React.createElement("text", {
  id: "name-00101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 584
})), React.createElement("text", {
  id: "name-0010101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 572
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 607
}, "7")), React.createElement("text", {
  id: "name-001011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 607
})), React.createElement("text", {
  id: "name-0010110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 597
})), React.createElement("text", {
  id: "name-0010111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 617
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 540.334483,
  x2: 75.4027778,
  y2: 579.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 580.5,
  x2: 77.5,
  y2: 580.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 762
}, "7")), React.createElement("text", {
  id: "name-001110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 762
})), React.createElement("text", {
  id: "name-0011100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 752
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 784
}, "6")), React.createElement("text", {
  id: "name-00111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 784
})), React.createElement("text", {
  id: "name-0011101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 772
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 807
}, "7")), React.createElement("text", {
  id: "name-001111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 807
})), React.createElement("text", {
  id: "name-0011110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 797
})), React.createElement("text", {
  id: "name-0011111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 817
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 740.334483,
  x2: 75.4027778,
  y2: 779.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 780.5,
  x2: 77.5,
  y2: 780.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 645.5,
  x2: 65.4027778,
  y2: 729.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 730.5,
  x2: 67.5,
  y2: 730.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 445.5,
  x2: 55.4027778,
  y2: 636.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 637.5,
  x2: 57.5,
  y2: 637.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 932
}, "5")), React.createElement("text", {
  id: "name-0100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 932
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 1039
}, "4")), React.createElement("text", {
  id: "name-010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 1039
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 52.7,
  y: 1239
}, "3")), React.createElement("text", {
  id: "name-01",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 67,
  y: 1239
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 962
}, "7")), React.createElement("text", {
  id: "name-010010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 962
})), React.createElement("text", {
  id: "name-0100100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 952
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 1134
}, "5")), React.createElement("text", {
  id: "name-0101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 1134
})), React.createElement("line", {
  x1: 65.4027778,
  y1: 930.334483,
  x2: 65.4027778,
  y2: 1026.66552,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 929.5,
  x2: 67.5,
  y2: 929.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 1036.33448,
  x2: 55.4027778,
  y2: 1225.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 1035.5,
  x2: 57.5,
  y2: 1035.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.4027778,
  y1: 1236.33448,
  x2: 35.4027778,
  y2: 846.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 884
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 862
}, "7")), React.createElement("text", {
  id: "name-01000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 884
})), React.createElement("text", {
  id: "name-010000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 862
})), React.createElement("text", {
  id: "name-0100000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 852
})), React.createElement("text", {
  id: "name-0100001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 872
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 907
}, "7")), React.createElement("text", {
  id: "name-010001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 907
})), React.createElement("text", {
  id: "name-0100010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 897
})), React.createElement("text", {
  id: "name-0100011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 917
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 880.334483,
  x2: 75.4027778,
  y2: 919.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 879.5,
  x2: 77.5,
  y2: 879.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1084
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1062
}, "7")), React.createElement("text", {
  id: "name-01010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1084
})), React.createElement("text", {
  id: "name-010100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1062
})), React.createElement("text", {
  id: "name-0101000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1052
})), React.createElement("text", {
  id: "name-0101001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1072
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1107
}, "7")), React.createElement("text", {
  id: "name-010101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1107
})), React.createElement("text", {
  id: "name-0101010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1097
})), React.createElement("text", {
  id: "name-0101011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1117
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1080.33448,
  x2: 75.4027778,
  y2: 1119.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1079.5,
  x2: 77.5,
  y2: 1079.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 984
}, "6")), React.createElement("text", {
  id: "name-01001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 984
})), React.createElement("text", {
  id: "name-0100101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 972
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1007
}, "7")), React.createElement("text", {
  id: "name-010011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1007
})), React.createElement("text", {
  id: "name-0100110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 997
})), React.createElement("text", {
  id: "name-0100111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1017
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 940.334483,
  x2: 75.4027778,
  y2: 979.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 980.5,
  x2: 77.5,
  y2: 980.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1162
}, "7")), React.createElement("text", {
  id: "name-010110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1162
})), React.createElement("text", {
  id: "name-0101100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1152
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1184
}, "6")), React.createElement("text", {
  id: "name-01011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1184
})), React.createElement("text", {
  id: "name-0101101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1172
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1207
}, "7")), React.createElement("text", {
  id: "name-010111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1207
})), React.createElement("text", {
  id: "name-0101110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1197
})), React.createElement("text", {
  id: "name-0101111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1217
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1140.33448,
  x2: 75.4027778,
  y2: 1179.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1180.5,
  x2: 77.5,
  y2: 1180.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 1045.5,
  x2: 65.4027778,
  y2: 1129.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 1130.5,
  x2: 67.5,
  y2: 1130.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 1332
}, "5")), React.createElement("text", {
  id: "name-0110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 1332
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 1439
}, "4")), React.createElement("text", {
  id: "name-011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 1439
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1362
}, "7")), React.createElement("text", {
  id: "name-011010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1362
})), React.createElement("text", {
  id: "name-0110100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1352
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 1534
}, "5")), React.createElement("text", {
  id: "name-0111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 1534
})), React.createElement("line", {
  x1: 63.5,
  y1: 1329.5,
  x2: 67.5,
  y2: 1329.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1284
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1262
}, "7")), React.createElement("text", {
  id: "name-01100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1284
})), React.createElement("text", {
  id: "name-011000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1262
})), React.createElement("text", {
  id: "name-0110000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1252
})), React.createElement("text", {
  id: "name-0110001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1272
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1307
}, "7")), React.createElement("text", {
  id: "name-011001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1307
})), React.createElement("text", {
  id: "name-0110010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1297
})), React.createElement("text", {
  id: "name-0110011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1317
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1280.33448,
  x2: 75.4027778,
  y2: 1319.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1279.5,
  x2: 77.5,
  y2: 1279.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1484
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1462
}, "7")), React.createElement("text", {
  id: "name-01110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1484
})), React.createElement("text", {
  id: "name-011100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1462
})), React.createElement("text", {
  id: "name-0111000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1452
})), React.createElement("text", {
  id: "name-0111001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1472
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1507
}, "7")), React.createElement("text", {
  id: "name-011101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1507
})), React.createElement("text", {
  id: "name-0111010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1497
})), React.createElement("text", {
  id: "name-0111011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1517
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1480.33448,
  x2: 75.4027778,
  y2: 1519.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1479.5,
  x2: 77.5,
  y2: 1479.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1384
}, "6")), React.createElement("text", {
  id: "name-01101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1384
})), React.createElement("text", {
  id: "name-0110101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1372
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1407
}, "7")), React.createElement("text", {
  id: "name-011011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1407
})), React.createElement("text", {
  id: "name-0110110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1397
})), React.createElement("text", {
  id: "name-0110111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1417
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1340.33448,
  x2: 75.4027778,
  y2: 1379.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1380.5,
  x2: 77.5,
  y2: 1380.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1562
}, "7")), React.createElement("text", {
  id: "name-011110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1562
})), React.createElement("text", {
  id: "name-0111100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1552
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1584
}, "6")), React.createElement("text", {
  id: "name-01111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1584
})), React.createElement("text", {
  id: "name-0111101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1572
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1607
}, "7")), React.createElement("text", {
  id: "name-011111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1607
})), React.createElement("text", {
  id: "name-0111110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1597
})), React.createElement("text", {
  id: "name-0111111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1617
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1540.33448,
  x2: 75.4027778,
  y2: 1579.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1580.5,
  x2: 77.5,
  y2: 1580.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 1445.5,
  x2: 65.4027778,
  y2: 1529.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 1530.5,
  x2: 67.5,
  y2: 1530.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 1245.5,
  x2: 55.4027778,
  y2: 1436.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 1437.5,
  x2: 57.5,
  y2: 1437.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 63.25,
  y1: 1329.5,
  x2: 63.25,
  y2: 1424.5,
  id: "Line",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 14.5,
  y1: 1627.5,
  x2: 14.5,
  y2: 836.5,
  id: "Line-2",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 14.5,
  y1: 835.5,
  x2: 27.5,
  y2: 835.5,
  id: "Line-3",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.34375,
  y1: 1236.5,
  x2: 46.5,
  y2: 1236.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}));

var SvgPedigree7GenFar = function SvgPedigree7GenFar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "200px",
    height: "1625px",
    viewBox: "0 0 200 1625",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPedigree7GenFar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pedigree-7gen-far.7f769818.svg";
export { ForwardRef as ReactComponent };